// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"72e77a82","455":"ad54b43c","977":"6e7fb8fb"}[chunkId] + ".chunk.js";
};